import { render, staticRenderFns } from "./RequestInfoStatusTag.vue?vue&type=template&id=40d91249"
import script from "./RequestInfoStatusTag.vue?vue&type=script&lang=js"
export * from "./RequestInfoStatusTag.vue?vue&type=script&lang=js"
import style0 from "./RequestInfoStatusTag.vue?vue&type=style&index=0&id=40d91249&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports